/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

import { reject } from 'rsvp';
import GroupCondition from 'cio/app-models/conditions/group';
import serialize from 'cio/utils/conditions/serialize';
import { isPresent } from '@ember/utils';
import deserialize from 'cio/utils/conditions/deserialize';
import SegmentModel from 'cio/models/segment';

interface SegmentSetupConditionsArgs {
  segment: SegmentModel;
  resetSegment: () => unknown;
  saveSegment: () => unknown;
}

export default class SegmentSetupConditions extends Component<SegmentSetupConditionsArgs> {
  @tracked conditionTree!: any; //TODO: type this?

  get isInvalid() {
    let { conditionTree } = this;
    return conditionTree.hasErrors || conditionTree.children.some((child: any) => child.hasErrors);
  }

  @action
  saveSegment() {
    if (!this.conditionTree.validate()) {
      return reject();
    }

    this.args.segment.set('conditions', serialize(this.conditionTree));

    return this.args.saveSegment();
  }

  constructor(owner: unknown, args: SegmentSetupConditionsArgs) {
    super(owner, args);

    let { conditions } = args.segment;
    let conditionTree = isPresent(conditions) ? deserialize(conditions) : GroupCondition.create();

    this.conditionTree = conditionTree;
  }
}
